import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.css']
})
export class PopupComponent implements OnInit {
  theme:string="";
  inter:any;
  @Input() timer:number;
  @Input() titulo:string;
  @Input() texto1:string;
  @Input() texto2:string;
  @Input() texto3:string;
  @Input() tipo:string;
  @Input() btn1:string = "";
  @Input() btn2:string = "";
  @Input() btn3:string = "";
  iniTimer:number;
  esError:boolean=false;


 
  constructor(public dialogRef: MatDialogRef<PopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    setTimeout(() => {
      this.fnCargaPopUp();
    }, 10);
    if(this.data){
        //console.log(this.data)
        this.timer = this.data.timer;
        this.titulo = this.data.titulo;
        this.texto1 = this.data.texto1;
        if(this.titulo.toUpperCase().indexOf("NO VÁLIDO") > 0)
          this.esError=true;
        this.iniTimer = this.texto1.indexOf(">|t|<")
        this.texto2 = this.data.texto2;
        this.texto3 = this.data.texto3;
        this.tipo = this.data.tipo; 
        this.btn1 = this.data.btn1;
        this.btn2 = this.data.btn2;
        this.btn3 = this.data.btn3;
    }
    else{
        this.timer = 25;
        this.titulo = "Atención"
        this.texto1 = `Parrafo1.`;
        this.texto2 = `Parrafo2.`;
        this.texto3 = `...`;
    }
  }
  
  onChange(): void {
    //console.log("onChange");
  }

  fnClick(operacion){
    console.log("click: " + operacion)
    if(operacion.toUpperCase() == "CONTINUAR"){
      this.dialogRef.close(operacion);
    }
    if(operacion.toUpperCase() == "ENTERADO"){
      this.dialogRef.close(operacion);
    }

  }

  ngOnDestroy(){
    clearInterval(this.inter);
    this.inter = null;    
  }

  fnCargaPopUp(){
    if(this.timer > 0){
      this.inter = setInterval(()=>{
        this.timer--;
        //console.log(this.timer);
        if (this.timer == 0){
          this.dialogRef.close('CERRADO');
        }
      },1000)
    }
  }


}

